import { combineReducers } from 'redux';
import { Map } from 'immutable';
import { pageComparator } from './page';
import { hasUpdate } from './contents';
import {
  SAVE_PAGE_SUCCESS,
  UPDATE_PAGE,
  UPDATE_PAGE_SUCCESS,
  UPDATE_PAGE_FAILURE,
  FETCH_PAGES,
  FETCH_PAGES_SUCCESS,
  FETCH_PAGES_FAILURE,
  FILTER_PAGES,
  SERIALIZE_PAGE,
  CANCEL_PENDING,
} from '../actions/pages';

const pages = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_PAGES_SUCCESS:
      return Map(action.response.entities.pages);
    case SAVE_PAGE_SUCCESS:
    case UPDATE_PAGE_SUCCESS:
      return state.merge(Map(action.response.entities.pages));
    default:
      return state;
  }
};

const pending = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_PAGES_SUCCESS:
      return Map(action.response.entities.pages);
    case SAVE_PAGE_SUCCESS:
    case UPDATE_PAGE_SUCCESS:
      return state.merge(Map(action.response.entities.pages));
    case SERIALIZE_PAGE:
    case CANCEL_PENDING:
      return state.set(action.page.id.toString(), action.page);
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_PAGES:
      return true;
    case FETCH_PAGES_SUCCESS:
    case FETCH_PAGES_FAILURE:
      return false;
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case FETCH_PAGES_FAILURE:
      return action.error;
    default:
      return state;
  }
};

const filter = (state = '', action) => {
  switch (action.type) {
    case FILTER_PAGES:
      return action.filter;
    default:
      return state;
  }
};

const isUpdating = (state = false, action) => {
  switch (action.type) {
    case UPDATE_PAGE:
      return true;
    case UPDATE_PAGE_SUCCESS:
    case UPDATE_PAGE_FAILURE:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  items: pages,
  pending,
  isFetching,
  error,
  filter,
  isUpdating,
});

export const getIsFetching = state => state.pages.isFetching;
export const getError = state => state.pages.error;

const getSortedPages = state => state.pages.items.sort(pageComparator);

export const getFilter = state => state.pages.filter;

export const getAllPages = state => {
  const filter = getFilter(state);
  const allPages = getSortedPages(state);

  const filterPage = page => {
    return (
      !page.isArchived &&
      (filter.length > 0
        ? page.name.toLowerCase().indexOf(filter.toLowerCase()) > -1
        : true)
    );
  };

  return allPages.filter(filterPage).toList();
};

export const getArchivedPages = state =>
  getSortedPages(state).filter(p => p.isArchived).toList();

export const getPageById = (state, id) => state.pages.items.get(id.toString());
export const getPendingPageById = (state, id) =>
  state.pages.pending.get(id.toString());

export const getRootPage = state => {
  const allPages = getAllPages(state);
  return allPages.find(p => p.isRoot);
};

export const hasContentUpdate = (state, id) => {
  const pending = state.pages.pending.get(id.toString());
  const existing = getPageById(state, id);

  return pending !== existing || hasUpdate(state, id);
};

export const getIsUpdating = state => state.pages.isUpdating;



// WEBPACK FOOTER //
// ./src/modules/catalog/reducers/pages.js